import { push } from 'react-router-redux';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { savePlanToVPC } from 'utils/vpc';
import { setSaveError, planLoading as applicationPlanLoading, showPlanSavedDialog as showPlanSavedDialogAction } from 'Application/actions';
import { currencySelector } from 'domain/LanguageProvider/selectors';
import { sendSavedDesign } from 'domain/Analytics/sagas';
import { kitchenIslandMeasurementsSelector } from 'domain/Options/selectors/measurements';
import { overhangSideMeasurementsSelector } from 'domain/Options/selectors/overhangMeasurements';

import { SAVE_PLAN } from '../constants';
import { planSaved, setPlanCode } from '../actions';
import { loadedLanguageSelector, planSelector } from '../selectors';
import { itemListSelector, totalPriceSelector, totalPriceInclFamilyPriceSelector } from '../itemList';
import serializePlan from '../utils/serializePlan';
import { freestandingHobsSelector } from '../selectors/operations';

export function* savePlan({ redirect, showPlanSavedDialog }) {
  yield put(applicationPlanLoading(true));
  const plan = yield select(planSelector);
  const locale = yield select(loadedLanguageSelector);
  const currency = yield select(currencySelector);
  const price = yield select(totalPriceSelector);
  const familyPrice = yield select(totalPriceInclFamilyPriceSelector);
  const kitchenIslandMeasurements = yield select(kitchenIslandMeasurementsSelector);
  const getOverhangMeasurements = yield select(overhangSideMeasurementsSelector);
  const overhangMeasurements = getOverhangMeasurements(plan.getIn(['overhangSide', 'value']));
  const freestandingHobMeasurements = yield select(freestandingHobsSelector);

  let serializedPlan;
  let items = [];
  serializedPlan = serializePlan(plan, { country: locale.country, currency, kitchenIslandMeasurements, overhangMeasurements, freestandingHobMeasurements, price, familyPrice });
  const itemList = (yield select(itemListSelector)).toJS();
  itemList.map((x)=>{
    if(x.amount > 0){
      items.push({
        itemType: x.item.ItemType,
        itemNo: x.item.ItemNo,
        quantity : x.amount
      });
    }
  });
  const inputData = JSON.stringify({
    application: "cwcalc",
    itemList: {
      item: items
    },
    configuration: {
      version: "1.0",
      content: serializedPlan
    }
  });
  try {
    const result = yield call(savePlanToVPC, locale, inputData);
    // eslint-disable-next-line no-console
    //console.log('Plan save result=', result);
    const code = result.configurationId;
    const isRunningInCTEF = window.location.href.includes('cte');
    if(!isRunningInCTEF){
      yield sendSavedDesign(itemList, code);
    }
    yield put(planSaved(code));
    yield put(setPlanCode(code));
    if (showPlanSavedDialog) {
      yield put(showPlanSavedDialogAction());
    }
    if (redirect) {
      yield put(push('/'));
    }
    yield put(setSaveError(false));
  } catch (error) {
    yield put(setSaveError(true));
    // eslint-disable-next-line no-console
    //console.error('Plan save ERROR', error);
  } finally {
    yield put(applicationPlanLoading(false));
  }
}

export default function* savePlanSaga() {
  yield takeLatest(SAVE_PLAN, savePlan);
}
